<template>
  <!-- 数据汇总 -->
  <el-card class="card-content card-content-cell-items">
    <div style="display: flex">
      <div class="card-icon" v-if="option.icon">
        <i :class="option.icon" class="iconfont"></i>
      </div>
      <div :class="{ 'disable-card': option.disable }" @click="handlerClick(option)" class="card-box-col" v-if="option">
        <!-- <div class="title">
          <span style="color: #8A909D">{{ option.title }}</span>

          <template v-if="option.tooltip">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">
                <div v-html="option.tooltip"></div>
              </div>
              <i class="icon-a-01wenhao iconfont-elicon"></i>
            </el-tooltip>
          </template>
          <template v-if="option.url">
            <a @click.stop="handleTo(option.url)">详情</a>
          </template>
        </div>-->
        <contentBox :option="option"></contentBox>
        <slot name="total"></slot>
        <template v-if="option.count && option.rate !== undefined">
          <div
            :class="{ 'disable-card': option.disable, t: !option.down }"
            :style="option.databoard ? 'position: absolute' : ''"
            class="rate"
          >
            <span class="text font-manrope">{{ option.rate }}</span>
            <span class="currency-icon">%</span>
            <i class="c-icon iconfont iconChevron-Top" style="transform: rotate(180deg)" v-if="option.down"></i>
            <i class="c-icon iconfont iconChevron-Top" v-else></i>
          </div>
        </template>
      </div>
    </div>
  </el-card>
</template>
<script>
import contentBox from './content'
export default {
  name: 'reportCard',
  components: {
    contentBox,
  },
  props: {
    option: {
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    handlerClick(option) {
      this.$emit('click', option)
    },
    handleTo(url) {
      this.$router.push(url)
    },
  },
}
</script>
<style lang="scss">
.card-content-cell-items {
  a {
    color: #556aff;
    position: absolute;
    right: 0;
    top: 0;
  }
  .title {
    font-size: 12px;
    .iconic-setting {
      float: right;
      cursor: pointer;
    }
  }
  .icon {
    color: #999999;
    margin-left: 8px;
    font-size: 14px;
  }
  .rate {
    position: relative;
    bottom: 0;
    right: 0;
    font-size: 14px;
    color: #00ce47;
    display: block;
    display: flex;
    align-items: center;
    margin-top: 20px;
    &.t {
      color: #ff0022;
    }
    span {
      font-weight: bold;
    }
  }
  .c-icon {
    display: inline-block;
    font-size: 16px;
    font-weight: bold;
    margin-left: 4px;
  }
  .content {
    margin-top: 12px;
    font-size: 22px;
    font-weight: bold;
  }
  &.active {
    color: #fff !important;
    background-color: #556aff;
    .icon {
      color: #fff !important;
      margin-left: 9px;
      font-size: 14px;
    }
    a {
      color: #fff;
    }
    .rate {
      position: relative;
      bottom: 0;
      right: 0;
      color: #fff;
      margin-top: 4px;

      &.t {
        color: #fff;
      }
    }
  }
  @media screen and (min-width: 1600px) {
    // .content {
    //   font-size: 28px;
    // }
    // .c-icon {
    //   font-size: 24px;
    // }
    .rate {
      position: absolute;
      margin-top: 0px;
      bottom: 0;
      right: 0;
      display: inline-block;
      margin-top: 0px;
      // font-size: 20px;
    }
    &.active {
      .rate {
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.card-content {
  &__popover {
    font-size: 14px;
    padding: 12px;
    font-family: MicrosoftYaHei;
    color: #010517;
    line-height: 14px;
    display: flex;
    align-items: center;
  }
  &__contentleft {
    margin-right: 40px;
  }
  &__top {
    margin-bottom: 24px;
  }
  .card-content-pop {
    min-width: 360px;
    font-weight: normal;
    line-height: 1.5;
  }

  padding: 6px 16px;
  // cursor: pointer;
  min-height: 96px;
  .currency-icon {
    font-size: 14px !important;
    // margin-left: 4px;
  }
  .card-box-col {
    position: relative;
    flex: 1;
  }
  a {
    color: #556aff;
    position: absolute;
    right: 0;
    top: 0;
  }
  .title {
    font-size: 12px;
  }
  .icon {
    color: #999999;
    margin-left: 8px;
    font-size: 14px;
  }
  .rate {
    position: relative;
    bottom: 0;
    right: 0;
    font-size: 14px;
    color: #00ce47;
    display: block;
    display: flex;
    align-items: center;
    margin-top: 20px;
    &.t {
      color: #ff0022;
    }
    span {
      font-weight: bold;
    }
  }
  .c-icon {
    font-size: 16px;
    font-weight: bold;
    margin-left: 4px;
  }
  .content {
    margin-top: 12px;
    font-size: 22px;
    font-weight: bold;
  }
  &.active {
    color: #fff !important;
    background-color: #556aff;
    .icon {
      color: #fff !important;
      margin-left: 9px;
      font-size: 14px;
    }
    a {
      color: #fff;
    }
    .rate {
      position: relative;
      bottom: 0;
      right: 0;
      color: #fff;
      margin-top: 4px;

      &.t {
        color: #fff;
      }
    }
  }
  @media screen and (min-width: 1600px) {
    // .content {
    //   font-size: 28px;
    // }
    // .c-icon {
    //   font-size: 24px;
    // }
    .rate {
      position: absolute;
      margin-top: 0px;
      bottom: 0;
      right: 0;
      display: inline-block;
      margin-top: 0px;
      // font-size: 20px;
    }
    &.active {
      .rate {
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
  }
}
.disable-card {
  color: #f0f2f5 !important;
}
.card-icon {
  width: 58px;
  height: 58px;
  background: #ecf2ff;
  border-radius: 50%;
  text-align: center;
  line-height: 58px;
  margin-right: 24px;
  .iconfont {
    font-size: 30px;
    color: #0560fd;
  }
}
</style>
